import { TApplication } from 'types/state';
import { sportingAPI } from 'services/sporting/api';
import { normalizeSportingClaim } from 'services/sporting/utils/normalizeSportingClaim';

export const getRestaurantNewApplications = async (): Promise<TApplication[]> => {
  const claims = await sportingAPI.service.getNewRestarauntClaims();

  return claims.map(claim =>
    normalizeSportingClaim.toApplication(claim, 'RESTAURANT_NEW')
  );
};
